import ContactColumn from './ContactColumn'

export default ContactColumn